export default __webpack_public_path__ + "static/media/meeting-arcade.6de1cf9c.md";